module.exports = __webpack_public_path__ + "static/media/enterprise_new.f2a734b1.png";